import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

class UploadModal extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    header: PropTypes.string,
    onConfirm: PropTypes.func,
    onModalStateChange: PropTypes.func,
    onClose: PropTypes.func,
    loading: PropTypes.bool,
    content: PropTypes.func,
    trigger: PropTypes.node,
    primary: PropTypes.bool,
    floated: PropTypes.string,
    btnText: PropTypes.string,
    icon: PropTypes.string,
    fluid: PropTypes.bool,
    disabled: PropTypes.bool,
    modalState: PropTypes.bool,
    t: PropTypes.func,
  }
  static defaultProps = {
    header: 'file',
    icon: 'cloud upload',
    btnText: 'Upload',
    primary: true,
    disabled: false,
  }
  static getPropsToState = (props) => {
    const state = {};
    // control modal state externally instead of based on trigger if modalState provided
    if (props.modalState !== null && props.modalState !== undefined) state.open = props.modalState;
    return {
      ...state,
    };
  }
  constructor(props) {
    super(props);
    const state = UploadModal.getPropsToState(props);
    this.state = {
      open: false,
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = UploadModal.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUpdate() {
    this.fixBody();
  }
  componentDidUpdate() {
    this.fixBody();
  }
  fixBody = () => {
    const anotherModal = document.getElementsByClassName('ui page modals');
    if (anotherModal && anotherModal.length > 0) {
      document.body.classList.add('dimmable', 'dimmed');
    }
  }
  handleOnOpen = () => {
    this.setState({ open: true }, () => {
      const { onModalStateChange } = this.props;
      if (onModalStateChange) {
        onModalStateChange(true);
      }
    });
  }
  close = () => {
    this.handleOnClose(true);
  }
  handleOnClose = (force = false) => {
    let open = false;
    if (!force && this.props.onClose) {
      open = this.props.onClose();
    }
    this.setState({ open }, () => {
      const { onModalStateChange } = this.props;
      if (onModalStateChange) {
        onModalStateChange(open);
      }
    });
  }
  handleOnConfirm = (e, data) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e, data);
    }
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        className="upload-modal"
        open={this.state.open}
        onOpen={() => this.handleOnOpen()}
        onClose={() => this.handleOnClose()}
        trigger={
          this.props.trigger ||
          <Button
            type="button"
            floated={this.props.floated}
            disabled={this.props.loading || this.props.disabled}
            primary={this.props.primary}
            fluid={this.props.fluid}
            icon={this.props.icon}
            labelPosition={this.props.icon ? 'left' : null}
            content={t(this.props.btnText, { ns: TRANSLATION_FILES.translation })}
          />
        }
        closeIcon="close"
        size="large"
      >
        <Header icon={this.props.icon} content={` ${t(this.props.btnText, { ns: TRANSLATION_FILES.translation })} ${t(this.props.header.toLowerCase(), { ns: TRANSLATION_FILES.translation })}`} />
        <Modal.Content>
          {
            this.props.content ? this.props.content({
              open: this.state.open,
              onClose: this.handleOnClose,
              onConfirm: this.handleOnConfirm,
            }) : null
          }
        </Modal.Content>
      </Modal>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(UploadModal);



// WEBPACK FOOTER //
// ./src/components/UploadModal.jsx